module.exports = __webpack_public_path__ + "static/media/domain_logo_United Kingdom.2771f714.svg";